import { FormikProps } from 'formik';
import { observer } from 'mobx-react-lite';
import { SavedViewDraft } from '../../interfaces/ISavedView';
import CheckboxInput from '../inputs/CheckboxInput';
import savedViewsStyles from "./SavedViews.module.css";

function SavedViewsFields({ formik }: { formik: FormikProps<SavedViewDraft> }) {
    return (
        <>
            <div className={savedViewsStyles.section}>
                <div className={savedViewsStyles.sectionTitle}>Includes</div>
                <div className={savedViewsStyles.visibilityRow}>
                    <CheckboxInput
                        formik={formik}
                        name="includeFocusArea"
                        label="Focus Area"
                    />
                    <CheckboxInput
                        formik={formik}
                        name="includeAllFilterSettings"
                        label="All Filter settings"
                    />
                    <CheckboxInput
                        formik={formik}
                        name="includeVisibleLayerSettings"
                        label="Layer settings"
                    />
                    <CheckboxInput
                        formik={formik}
                        name="includeBaseMapSettings"
                        label="Base map settings"
                    />
                    <CheckboxInput
                        formik={formik}
                        name="includeCompanyIdsToViewOnMap"
                        label="Companies to View on Map"
                    />
                </div>
            </div>

            <div className={savedViewsStyles.section}>
                <div className={savedViewsStyles.sectionTitle}>Visibility</div>
                <div className={savedViewsStyles.visibilityRow}>
                    <CheckboxInput
                        checked={formik.values.isShared}
                        formik={formik}
                        name="isShared"
                        label="Shared View"
                    />
                </div>
            </div>
        </>
    );
}

export default observer(SavedViewsFields);
